import React from "react";
import { Link } from "react-router-dom";
import useFetchData from "../Hooks/useFetchData";
import kenya from "./../kenya.png";
const Sidebar = () => {
  let UserId = window.sessionStorage.getItem("UserId");
  const UserRoles = useFetchData("/api/UserRoles/byUserId?userId=" + UserId);
  const UserManagementModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Security Groups", "View") ? (
          <li>
            <Link to="/SecurityGroups">SecurityGroups </Link>
          </li>
        ) : null}
        {useValidateRole("Users", "View") ? (
          <li>
            <Link to="/Users">Users </Link>
          </li>
        ) : null}
        {/* {useValidateRole("Approvers", "View") ? (
          <li>
            <Link to="/Approvers">Approvers</Link>
          </li>
        ) : null} */}
        {useValidateRole("Roles", "View") ? (
          <li>
            <Link to="/Roles">Roles</Link>
          </li>
        ) : null}
        {useValidateRole("AuditTrails", "View") ? (
          <li>
            <Link to="/AuditTrails">AuditTrails</Link>
          </li>
        ) : null}
      </ul>
    );
  };
  const useValidateRole = (rolename, action) => {
    if (UserRoles.response) {
      let role = UserRoles.response.data.find(
        (obj) => obj.permission.name === rolename,
      );
      if (role) {
        if (action === "AddNew") {
          if (role.addRecord === 1) {
            return true;
          } else {
            return false;
          }
        } else if (action === "View") {
          if (role.viewRecord === 1) {
            return true;
          } else {
            return false;
          }
        } else if (action === "Edit") {
          if (role.editRecord === 1) {
            return true;
          } else {
            return false;
          }
        } else if (action === "Export") {
          if (role.exportRecord === 1) {
            return true;
          } else {
            return false;
          }
        } else if (action == "Remove") {
          if (role.deleteRecord === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  const ConfigurationModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Incident Types", "View") ? (
          <li>
            <Link to="/IncidentTypes">Incident Types</Link>
          </li>
        ) : null}
        {useValidateRole("Product Category", "View") ? (
          <li>
            <Link to="/ProductCategory">Product Category</Link>
          </li>
        ) : null}
        {useValidateRole("Product Status", "View") ? (
          <li>
            <Link to="/ProductStatus">Policy Status</Link>
          </li>
        ) : null}
        {useValidateRole("MOU Status", "View") ? (
          <li>
            <Link to="/MOUStatus">MOU Status</Link>
          </li>
        ) : null}
        {useValidateRole("Document Type", "View") ? (
          <li>
            <Link to="/docType">Document Type</Link>
          </li>
        ) : null}

        {useValidateRole("Incident LikelyHood", "View") ? (
          <li>
            <Link to="/IncidentLikelyHood">IncidentLikelyHood</Link>
          </li>
        ) : null}
        {useValidateRole("Severity Level", "View") ? (
          <li>
            <Link to="/SeverityLevel">Severity Level</Link>
          </li>
        ) : null}
        {useValidateRole("Countries", "View") ? (
          <li>
            <Link to="/Countries">Countries </Link>
          </li>
        ) : null}
        {useValidateRole("Counties", "View") ? (
          <li>
            <Link to="/Counties">Counties </Link>
          </li>
        ) : null}
        {useValidateRole("Approval setup", "View") ? (
          <li>
            <Link to="/Approvalsetup">Approval setup </Link>
          </li>
        ) : null}
        {useValidateRole("approvers", "View") ? (
          <li>
            <Link to="/approvers">Approvers</Link>
          </li>
        ) : null}
        {/* {useValidateRole("Approval Modules", "View") ? (
          <li>
            <Link to="/approvermodules">Approval Modules </Link>
          </li>
        ) : null} */}
        {useValidateRole("Towns", "View") ? (
          <li>
            <Link to="/Towns">Towns</Link>
          </li>
        ) : null}
        {useValidateRole("Wards", "View") ? (
          <li>
            <Link to="/Wards">Wards</Link>
          </li>
        ) : null}

        {useValidateRole("Organizations", "View") ? (
          <li>
            <Link to="/Organization">Organizations</Link>
          </li>
        ) : null}
        {useValidateRole("Departments", "View") ? (
          <li>
            <Link to="/Departments">Departments</Link>
          </li>
        ) : null}
        {useValidateRole("Financial Year", "View") ? (
          <li>
            <Link to="/financialyear">Financial year</Link>
          </li>
        ) : null}
      </ul>
    );
  };
  const TourismProductModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Add Products", "View") ? (
          <li>
            <Link to="/AddProducts">Products </Link>
          </li>
        ) : null}

        {useValidateRole("Product Hours", "View") ? (
          <li>
            <Link to="/ProductHours">Product Hours</Link>
          </li>
        ) : null}
      </ul>
    );
  };
  const VettingExpartriateModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Vetting Committee", "View") ? (
          <li>
            <Link to="/VettingCommittee">Vetting Committee</Link>
          </li>
        ) : null}
        {useValidateRole("Applications", "View") ? (
          <li>
            <Link to="/NewApplication">New Application</Link>
          </li>
        ) : null}
        {useValidateRole("Vetting Session", "View") ? (
          <li>
            <Link to="/VetingSession">Vetting Session</Link>
          </li>
        ) : null}
        {useValidateRole("Document perusal", "View") ? (
          <li>
            <Link to="/DecumentPerusal">Document perusal</Link>
          </li>
        ) : null}

        {useValidateRole("Verification", "View") ? (
          <li>
            <Link to="/Applications">Verification</Link>
          </li>
        ) : null}

        {useValidateRole("Approval", "View") ? (
          <li>
            <Link to="/Approval">Approval</Link>
          </li>
        ) : null}
        {useValidateRole("Permit issue", "View") ? (
          <li>
            <Link to="/Permit">Permit issue</Link>
          </li>
        ) : null}
        {useValidateRole("Permit registry", "View") ? (
          <li>
            <Link to="/Applications">Permit registry</Link>
          </li>
        ) : null}
        {useValidateRole("Employers", "View") ? (
          <li>
            <Link to="/Employers">Employers</Link>
          </li>
        ) : null}
        {useValidateRole("Permits", "View") ? (
          <li>
            <Link to="/Permits">Permits</Link>
          </li>
        ) : null}
        {useValidateRole("Permit Classes", "View") ? (
          <li>
            <Link to="/PermitClasse">Permit Classes</Link>
          </li>
        ) : null}
        {useValidateRole("Dependants Types", "View") ? (
          <li>
            <Link to="/DependantsTypes">Dependants Types</Link>
          </li>
        ) : null}
      </ul>
    );
  };
  const MEModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Indicators", "View") ? (
          <li>
            <Link to="/Indicators">Indicators</Link>
          </li>
        ) : null}
        {useValidateRole("Employers", "View") ? (
          <li>
            <Link to="/Employers">Employers</Link>
          </li>
        ) : null}
        {useValidateRole("Permits", "View") ? (
          <li>
            <Link to="/Permits">Permits</Link>
          </li>
        ) : null}
        {useValidateRole("Permit Classes", "View") ? (
          <li>
            <Link to="/PermitClasse">Permit Classes</Link>
          </li>
        ) : null}
        {useValidateRole("Dependants Types", "View") ? (
          <li>
            <Link to="/DependantsTypes">Dependants Types</Link>
          </li>
        ) : null}
      </ul>
    );
  };

  const PerformanceModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Performance Contracting", "View") ? (
          <li>
            <Link to="/PerformanceContracting">Performance Contracting</Link>
          </li>
        ) : null}
        {useValidateRole("Strategic Objective", "View") ? (
          <li>
            <Link to="/StrategicObjective">Strategic Objective</Link>
          </li>
        ) : null}
        {useValidateRole("Projects Activities", "View") ? (
          <li>
            <Link to="/ProjectsActivities">Projects/Activities</Link>
          </li>
        ) : null}
        {useValidateRole("Kpi Target", "View") ? (
          <li>
            <Link to="/KpiTarget">KpiTarget</Link>
          </li>
        ) : null}
        {useValidateRole("Progress Updates", "View") ? (
          <li>
            <Link to="/ProgressUpdates">Progress Updates</Link>
          </li>
        ) : null}

        {useValidateRole("Organization Performance", "View") ? (
          <li>
            <Link to="/OrganizationPerformance">Organization Performance</Link>
          </li>
        ) : null}
        {useValidateRole("Self Appraisal", "View") ? (
          <li>
            <Link to="/SelfAppraisal">SelfAppraisal</Link>
          </li>
        ) : null}
        {useValidateRole("Supervisor Review", "View") ? (
          <li>
            <Link to="/SelfAppraisal">Supervisor Review</Link>
          </li>
        ) : null}
      </ul>
    );
  };

  const MOUsModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Add Mous", "View") ? (
          <li>
            <Link to="/AddMous">MOUs</Link>
          </li>
        ) : null}
      </ul>
    );
  };
  const InvestmentsModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Add Investments", "View") ? (
          <li>
            <Link to="/AddInvestments">Investments</Link>
          </li>
        ) : null}
      </ul>
    );
  };
  const PolicyAndResearchModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Add Policy And Research", "View") ? (
          <li>
            <Link to="/Policy">Policy and Research</Link>
          </li>
        ) : null}
      </ul>
    );
  };
  const MarketingModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Marketing and promotion", "View") ? (
          <li>
            <Link to="/Marketing">Marketing</Link>
          </li>
        ) : null}
      </ul>
    );
  };
  const TourismSafetyModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Security Incidents", "View") ? (
          <li>
            <Link to="/SecurityIncident">Security Incident</Link>
          </li>
        ) : null}
      </ul>
    );
  };

  const ReportsModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Products Report", "View") ? (
          <li>
            <Link to="/products_report">Products </Link>
          </li>
        ) : null}
        {useValidateRole("Mou Report", "View") ? (
          <li>
            <Link to="/mou_report">MOU</Link>
          </li>
        ) : null}
        {useValidateRole("Investments Report", "View") ? (
          <li>
            <Link to="/investments_report">Investments</Link>
          </li>
        ) : null}
        {useValidateRole("Products Per County Report", "View") ? (
          <li>
            <Link to="/ProductsPerCountyReport">Products Per CountyReport</Link>
          </li>
        ) : null}
        {useValidateRole("Products/Sites per Region and County", "View") ? (
          <li>
            <Link to="/SitesPerCounty">Sites per Region and County</Link>
          </li>
        ) : null}
        {useValidateRole("Tourism Safety Report", "View") ? (
          <li>
            <Link to="/safety_report">Tourism Safety</Link>
          </li>
        ) : null}
        {useValidateRole("Project Status Summary Report", "View") ? (
          <li>
            <Link to="/OrganizationPerformanceReport">
              Project Status Summary Report
            </Link>
          </li>
        ) : null}
        {useValidateRole("Staff Performance Summary Report", "View") ? (
          <li>
            <Link to="/StaffPerformanceSummaryReport">
              Staff Performance Summary
            </Link>
          </li>
        ) : null}
      </ul>
    );
  };
  const ApprovalModule = () => {
    return (
      <ul className="sub-menu">
        {useValidateRole("Capitation Approval", "View") ? (
          <li>
            <Link to="/Capitationsubmited">Capitation Approval </Link>
          </li>
        ) : null}
        {useValidateRole("Bank Accounts Approval", "View") ? (
          <li>
            <Link to="/BankAccountsApproval">Bank Accounts Approval</Link>
          </li>
        ) : null}
        {useValidateRole("Institution Approval", "View") ? (
          <li>
            <Link to="/InstitutionsApproval">Institution Approval </Link>
          </li>
        ) : null}
        {useValidateRole("User Approval", "View") ? (
          <li>
            <Link to="/UserApproval">User Approval </Link>
          </li>
        ) : null}
      </ul>
    );
  };

  return (
    <div id="sidebar" className="sidebar">
      <div data-scrollbar="true" data-height="100%">
        <ul className="nav">
          <li className="nav-profile">
            <div className="image">
              <img src={kenya} alt="" />
            </div>
            <div className="info">
              <small>{window.sessionStorage.getItem("UserName")}</small>
            </div>
          </li>
        </ul>
        <ul className="nav">
          <li>
            <b className="caret"></b>
            <i className="fa fa-address-book"></i>
            <Link to="/DashBoard">
              {" "}
              <span>DashBoard</span>{" "}
            </Link>
          </li>
          {useValidateRole("User Management", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-user-circle"></i>
                <span>User Management</span>
              </a>
              <UserManagementModule />
            </li>
          ) : null}
          {useValidateRole("Approvals", "View") ? (
            <li className="has-sub ">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-address-book"></i>
                <span>Approvals</span>
              </a>
              <ApprovalModule />
            </li>
          ) : null}
          {useValidateRole("Configurations", "View") ? (
            <li className="has-sub ">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-puzzle-piece"></i>
                <span>Configurations</span>
              </a>
              <ConfigurationModule />
            </li>
          ) : null}
          {useValidateRole("TourismProducts", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-binoculars"></i>
                <span>Product development</span>
              </a>
              <TourismProductModule />
            </li>
          ) : null}
          {useValidateRole("MOUs", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-book"></i>
                <span>MOUs</span>
              </a>
              <MOUsModule />
            </li>
          ) : null}
          {useValidateRole("Investments", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-pie-chart"></i>
                <span>Tourism Investments & Finance</span>
              </a>
              <InvestmentsModule />
            </li>
          ) : null}
          {useValidateRole("Marketing", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-bullhorn"></i>
                <span>Marketing & Promotion</span>
              </a>
              <MarketingModule />
            </li>
          ) : null}

          {useValidateRole("TourismSafety", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-ambulance"></i>
                <span>Tourism and Safety</span>
              </a>
              <TourismSafetyModule />
            </li>
          ) : null}
          {useValidateRole("VettingExpartriates", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-search-plus"></i>
                <span>Vetting of Expatriates</span>
              </a>
              <VettingExpartriateModule />
            </li>
          ) : null}

          {useValidateRole("Policy and Research", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-search-plus"></i>
                <span>Policy and Research</span>
              </a>
              <PolicyAndResearchModule />
            </li>
          ) : null}
          {useValidateRole("MonitoringAndEvaluation", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-search-plus"></i>
                <span>Monitoring and Evaluation</span>
              </a>
              <MEModule />
            </li>
          ) : null}
          {useValidateRole("Performance Management", "View") ? (
            <li className="has-sub">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-search-plus"></i>
                <span>Performance Management</span>
              </a>
              <PerformanceModule />
            </li>
          ) : null}
          {useValidateRole("Reports", "View") ? (
            <li className="has-sub ">
              <a href="javascript:;">
                <b className="caret"></b>
                <i className="fa fa-address-book"></i>
                <span>Reports</span>
              </a>
              <ReportsModule />
            </li>
          ) : null}

          <li>
            <a
              href="javascript:;"
              className="sidebar-minify-btn"
              data-click="sidebar-minify"
            >
              <i className="fa fa-angle-double-left"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default Sidebar;
